const datas = {
  products: [
    {
      id: 1,
      category: "athlete",
      type: "chuck taylor",
      colors: ["red"],
      shoeImages: [
        "https://s2.uupload.ir/files/chucktaylor-blackwhite_(1)_(3)_(1)_cu68.jpg",
        "https://s2.uupload.ir/files/images_wb74.jpg",
        "https://s2.uupload.ir/files/converse-chuck-taylor-all-star-pro-black-mid-top-skate-shoes-_355701-front-us_qrfb.png",
      ],
      price: "19.9",
      priceType: "USD",
      itemStars: 2.5,
    },
    {
      id: 2,
      category: "hiking",
      type: "boots",
      colors: ["white", "orange"],
      shoeImages: [
        "https://s2.uupload.ir/files/sneaker-whiteorange-2_(1)_(2)_cwar.jpg",
        "https://s2.uupload.ir/files/s-l500_ejz2.jpg",
        "https://s2.uupload.ir/files/617nqg0kuwl._ac_uf1000,1000_ql80__3uni.jpg",
      ],
      price: "24.9",
      priceType: "USD",
      itemStars: 2.5,
    },
    {
      id: 3,
      category: "walking",
      type: "sneaker",
      colors: ["green"],
      shoeImages: ["https://s2.uupload.ir/files/sneaker-green_jvm.jpg"],
      price: "70",
      priceType: "USD",
      itemStars: 4,
    },
    {
      id: 4,
      category: "athlete",
      type: "sneaker",
      colors: ["blue"],
      shoeImages: ["https://s2.uupload.ir/files/sneaker-blue-1_46yy.jpg"],
      price: "4.9",
      priceType: "USD",
      itemStars: 1.5,
    },
    {
      id: 5,
      category: "walking",
      type: "oldSchool",
      shoe: "old school",
      colors: ["red"],
      shoeImages: ["https://s2.uupload.ir/files/sneaker-red-1_(1)_aq36.jpg"],
      price: "13.49",
      priceType: "USD",
      itemStars: 2,
    },
    {
      id: 6,
      category: "hiking",
      type: "work boots",
      colors: ["black", "white", "brown"],
      shoeImages: [
        "https://s2.uupload.ir/files/sneaker-blackwhitebrown-1_vs6w.jpg",
        "https://s2.uupload.ir/files/res_304cf971dccfaede71668635b927cf98_1dl2.png",
        "https://s2.uupload.ir/files/71ecrmezkjl._ux625__d9ul.jpg",
      ],
      price: "100",
      isDiscount: true,
      offPrice: "70",
      priceType: "USD",
      itemStars: 4.5,
    },
    {
      id: 7,
      category: "dancing",
      type: "chuck taylor",
      colors: ["black", "white"],
      shoeImages: [
        "https://s2.uupload.ir/files/sneaker-blackwhite-1_(1)_(2)_p6y5.jpg",
      ],
      price: "62.19",
      isDiscount: true,
      offPrice: "42.5",
      priceType: "USD",
      itemStars: 3.5,
    },
    {
      id: 8,
      category: "dancing",
      type: "sneaker",
      colors: ["brown", "white"],
      shoeImages: [
        "https://s2.uupload.ir/files/sneaker-darkbrown_(1)_z0y7.jpg",
      ],
      price: "49.9",
      isDiscount: true,
      offPrice: "35",
      priceType: "USD",
      itemStars: 3,
    },
    {
      id: 9,
      category: "daily usage",
      type: "oldSchool",
      shoe: "old school",
      colors: ["white"],
      shoeImages: [
        "https://s2.uupload.ir/files/oldschool-whiteblack_(2)_(2)_qdh.jpg",
        "https://s2.uupload.ir/files/92bd338a-7fb5-4a7d-8132-f43bc8fe856a_uqjd.jpg",
        "https://s2.uupload.ir/files/d223ea7d-84a2-44ac-b89a-b6e9b71ed575_ew9.png",
        "https://s2.uupload.ir/files/4d102c3d-7946-491b-a894-6dde5bbf6164_h2sm.png",
        "https://s2.uupload.ir/files/d223ea7d-84a2-44ac-b89a-b6e9b71ed575_ipl7.png",
      ],
      price: "119.9",
      isDiscount: true,
      offPrice: "59.9",
      priceType: "USD",
      itemStars: 5,
    },
  ],
  users: [],
  usersCart: [],
};

export default datas;
